import { Fragment } from 'react';

import useOrgUnitAdminPurchases from './UseOrgUnitAdminPurchases';

import OrgUnitAdminPurchasesGrid from './OrgUnitAdminPurchasesGrid';
import OrgUnitAdminAdditionalPurchasesGrid from './OrgUnitAdminAdditionalPurchasesGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import Constants from '@usas/ui-web/utils/Constants';

import style from '../../Entry.module.css';

const OrgUnitAdminPurchasesReadOnly = () => {
  const { omeMeetOrgUnitEntryPurchaseState, errorState, onAdditionalPurchaseValueChanged, onBackClicked, onExitButtonClicked
  } = useOrgUnitAdminPurchases();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H6>Required Purchases</Headings.H6>
        </div>
        <div className="col-xs-12">
          <OrgUnitAdminPurchasesGrid
            gridData={omeMeetOrgUnitEntryPurchaseState.objData?.purchaseItem}
            isLoading={omeMeetOrgUnitEntryPurchaseState.isObjLoading}
          />
        </div>
        {omeMeetOrgUnitEntryPurchaseState.objData?.additionalPurchase?.length > 0 &&
          <Fragment>
            <div className="col-xs-12 usas-extra-top-margin">
              <Headings.H6>Additional Purchases</Headings.H6>
            </div>
            <div className="col-xs-12">
              <OrgUnitAdminAdditionalPurchasesGrid
                gridData={omeMeetOrgUnitEntryPurchaseState.objData?.additionalPurchase}
                isLoading={omeMeetOrgUnitEntryPurchaseState.isObjLoading}
                errorState={errorState}
                onAdditionalPurchaseValueChanged={onAdditionalPurchaseValueChanged}
              />
            </div>
          </Fragment>}
        <div className={style.FloatRight}>
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <SecondaryButton onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
            <PrimaryButton onClick={onExitButtonClicked}>Exit</PrimaryButton>
          </div>
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={omeMeetOrgUnitEntryPurchaseState.isObjLoading}
      />
    </Fragment>
  );
};

export default OrgUnitAdminPurchasesReadOnly;